export const PAYMENT_TERMS_BASIS = ['invoice_date', 'end_of_month'] as const

export type PaymentTermsBasis = (typeof PAYMENT_TERMS_BASIS)[number]

export const PAYMENT_TERMS_DAY_PRESETS = [15, 30, 45, 60] as const

export const DEFAULT_PAYMENT_TERMS = {
  days: 30,
  basis: 'invoice_date' as PaymentTermsBasis,
} as const

export const PAYMENT_TERMS_DAYS_MIN = 1
export const PAYMENT_TERMS_DAYS_MAX = 365

export function isPaymentTermsDaysPreset(value: number): boolean {
  return PAYMENT_TERMS_DAY_PRESETS.includes(value as (typeof PAYMENT_TERMS_DAY_PRESETS)[number])
}

export const PRE_ACCEPTANCE_MISSION_DISPLAY_STATUSES = new Set([
  'draft',
  'pending-approval',
  'pending-freelancer-review',
  'pending-company-review',
  'rejected',
  'awaiting-freelancer-acceptance',
])

export function canEditMissionPaymentTerms(displayStatus?: string | null): boolean {
  if (!displayStatus) return false
  return PRE_ACCEPTANCE_MISSION_DISPLAY_STATUSES.has(String(displayStatus).trim())
}

type MissionPaymentTermsSource = {
  payment_terms_days?: number | string | null
  paymentTermsDays?: number | string | null
  payment_terms_basis?: string | null
  paymentTermsBasis?: string | null
}

export function getMissionPaymentTermsDays(mission?: MissionPaymentTermsSource | null): number {
  const raw = mission?.payment_terms_days ?? mission?.paymentTermsDays
  if (raw == null || raw === '') return DEFAULT_PAYMENT_TERMS.days
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : DEFAULT_PAYMENT_TERMS.days
}

export function getMissionPaymentTermsBasis(mission?: MissionPaymentTermsSource | null): PaymentTermsBasis {
  const raw = mission?.payment_terms_basis ?? mission?.paymentTermsBasis
  return raw === 'end_of_month' ? 'end_of_month' : DEFAULT_PAYMENT_TERMS.basis
}
